import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { Form, Button, Navbar, Container, Modal } from "react-bootstrap";
import "./teacher_form.css";
import Swal from "sweetalert2";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import th from "date-fns/locale/th";
import format from "date-fns/format";
import Loader from "../../components/Loader";
import config from "../../assets/api/config";
import logo from "../../assets/logo.webp";
registerLocale("th", th);

const Teacher_Form = () => {
  const [activityYear, setActivityYear] = useState("");
  const [semesterOptions, setSemesterOptions] = useState([]);
  const [activityName, setActivityName] = useState("");
  const [activityDate, setActivityDate] = useState("");
  const [lastDate, setLastDate] = useState("");
  const [activityPlace, setActivityPlace] = useState("");
  const [activityPictures, setActivityPictures] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [formattedDate, setFormattedDate] = useState("");
  const [formattedLastDate, setFormattedLastDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [openConModal, setOpenConModal] = useState(false);
  const [answers, setAnswers] = useState({
    question1: null,
    question2: null,
    question3: null,
    question4: null,
  });

  console.log(answers);

  const [errors, setErrors] = useState({});

  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const ciphertext = decodeURIComponent(params.get("q"));
  const bytes = CryptoJS.AES.decrypt(ciphertext, "secret key 123");
  const plaintext = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  const [user_id] = useState(plaintext.user_id);
  const [fullname] = useState(plaintext.fullname);
  const [department] = useState(plaintext.department);
  const navigate = useNavigate();
  const hostName = config.hostName;

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/");
      return;
    }
    setOpenConModal(true);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `https://i.vu.ac.th/research_api/semester-year`
        ); // Update the URL accordingly
        const data = await response.json();
        setSemesterOptions(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handleDeletePicture = (event, index) => {
    event.preventDefault();
    const newImages = [...activityPictures];
    newImages.splice(index, 1);
    setActivityPictures(newImages);
  };

  const validateForm = () => {
    let errors = {};
    if (!activityYear) {
      errors.activityYear = "กรุณาเลือกปีการศึกษา/ภาคเรียน";
    }
    if (!activityName) {
      errors.activityName = "กรุณากรอกชื่อกิจกรรม";
    }
    if (!activityDate) {
      errors.activityDate = "กรุณาเลือกวันที่จัดกิจกรรม";
    }
    if (!lastDate) {
      errors.lastDate = "กรุณาเลือกวันที่สิ้นสุดกิจกรรม";
    }
    if (!activityPlace) {
      errors.activityPlace = "กรุณากรอกสถานที่ที่จัดกิจกรรม";
    }
    if (!selectedDepartment) {
      errors.selectedDepartment = "กรุณาเลือกคณะ ศูนย์  สำนัก";
    }
    return errors;
  };

  const handleFormSubmit = () => {
    const errors = validateForm();
    setErrors(errors);
    if (Object.keys(errors).length === 0) {
      setLoading(true);
      const formData = new FormData();
      const formattedDate = format(activityDate, "yyyy-MM-dd");
      const formattedLastDate = format(lastDate, "yyyy-MM-dd");
      formData.append("activity_name", activityName);
      formData.append("activity_year", activityYear);
      formData.append("activity_date", formattedDate);
      formData.append("last_date", formattedLastDate);
      formData.append("teacher_id", user_id);
      formData.append("teacher_name", fullname);
      formData.append("activity_place", activityPlace);

      activityPictures.forEach((file) => {
        formData.append("activity_pictures", file);
      });

      const [depId, depName] = selectedDepartment.split(",");
      const departmentData = { dep_id: depId, dep_name: depName };
      const departmentJSON = JSON.stringify(departmentData);
      formData.append("department", departmentJSON);

      fetch(`${hostName}/teacher_form`, {
        method: "POST",
        body: formData,
      })
        .then((response) => {
          if (response.ok) {
            setLoading(false);
            console.log("Form submitted successfully!");
            Swal.fire({
              icon: "success",
              title: "เพิ่มข้อมูลสำเร็จ",
              showConfirmButton: false,
              timer: 1500,
              customClass: {
                title: "thai-font",
              },
            });
            navigate(-1);
          } else {
            setLoading(false);
            console.error("Error submitting form");
            Swal.fire({
              icon: "error",
              text: "กรุณากรอกข้อมูลให้ถูกต้อง",
            });
          }
        })
        .catch((error) => {
          setLoading(false);
          console.error(error);
        });
    } else {
      console.error("Error submitting form");
      Swal.fire({
        icon: "error",
        text: "กรุณากรอกข้อมูลให้ถูกต้อง",
      });
    }
  };

  const handleDateChange = (e) => {
    setActivityDate(e);
    const date = new Date(e);
    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
      weekday: "long",
    };
    const formattedDate = date.toLocaleDateString("th-TH", options);
    setFormattedDate(formattedDate);
  };

  const handleLastDateChange = (e) => {
    setLastDate(e);
    const date = new Date(e);
    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
      weekday: "long",
    };
    const formattedLastDate = date.toLocaleDateString("th-TH", options);
    setFormattedLastDate(formattedLastDate);
  };

  const hiddenFileInputStyle = {
    display: "none",
  };

  const handleFileChange = (e) => {
    const files = e.target.files;
    // Handle the file change logic here
    setActivityPictures([...activityPictures, ...files]);
  };

  const handleYes = (question) => {
    // Set the answer for the given question
    setAnswers({ ...answers, [question]: true });
  };

  const handleNo = (question) => {
    // Set the answer for the given question
    setAnswers({ ...answers, [question]: false });
  };

  return (
    <div>
      <div className="navbar-parent-container">
        <Navbar
          expand="lg"
          variant="light"
          style={{ backgroundColor: "#EFC001", height: "60px", width: "100vw" }}
          fluid="true"
          className="navbar"
        >
          <Container className="navbar_container" fluid>
            <Navbar.Brand>
              <img
                alt=""
                src={logo}
                style={{ width: 40, height: 40 }}
                className="d-inline-block align-top"
              />{" "}
              <span
                className="thai-font"
                style={{ fontWeight: "bold", color: "black" }}
              >
                VU Volunteer Teacher
              </span>
            </Navbar.Brand>
          </Container>
        </Navbar>
      </div>{" "}
      {openConModal && (
        <Modal show={openConModal} className="thai-font">
          <Modal.Header>
            <Modal.Title style={{ fontWeight: "bold" }}>
              ลักษณะของกิจกรรมจิตอาสา
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ fontSize: 22, fontWeight: "bold" }}>
            <div>
              <p>
                1. กิจกรรมจิตอาสานี้
                <span style={{ color: "#CF5B05" }}>ไม่เป็น</span>
                ส่วนหนึ่งของผลการเรียนในรายวิชา
              </p>
              <div style={{ marginTop: -10 }}>
                <input
                  type="radio"
                  id="yesQuestion1"
                  name="question1"
                  value="yes"
                  onChange={() => handleYes("question1")}
                />
                <label htmlFor="yesQuestion1" style={{ marginLeft: 10 }}>
                  ใช่
                </label>

                <input
                  type="radio"
                  id="noQuestion1"
                  name="question1"
                  value="no"
                  style={{ marginLeft: 40 }}
                  onChange={() => handleNo("question1")}
                />
                <label htmlFor="noQuestion1" style={{ marginLeft: 10 }}>
                  ไม่ใช่
                </label>
              </div>
            </div>
            <div>
              <p>
                2. กิจกรรมจิตอาสา<span style={{ color: "#CF5B05" }}>ไม่มี</span>
                ค่าตอบแทนใดๆ
              </p>
              <div style={{ marginTop: -10 }}>
                <input
                  type="radio"
                  id="yesQuestion2"
                  name="question2"
                  value="yes"
                  onChange={() => handleYes("question2")}
                />
                <label htmlFor="yesQuestion2" style={{ marginLeft: 10 }}>
                  ใช่
                </label>

                <input
                  type="radio"
                  id="noQuestion2"
                  name="question2"
                  value="no"
                  style={{ marginLeft: 40 }}
                  onChange={() => handleNo("question2")}
                />
                <label htmlFor="noQuestion2" style={{ marginLeft: 10 }}>
                  ไม่ใช่
                </label>
              </div>
            </div>
            <div>
              <p>
                3. กิจกรรมจิตอาสานี้
                <span style={{ color: "#CF5B05" }}>ไม่ใช่</span>
                การเข้าอบรมเพิ่มความรู้กับนักศึกษา
              </p>
              <div style={{ marginTop: -10 }}>
                <input
                  type="radio"
                  id="yesQuestion3"
                  name="question3"
                  value="yes"
                  onChange={() => handleYes("question3")}
                />
                <label htmlFor="yesQuestion3" style={{ marginLeft: 10 }}>
                  ใช่
                </label>

                <input
                  type="radio"
                  id="noQuestion3"
                  name="question3"
                  value="no"
                  onChange={() => handleNo("question3")}
                  style={{ marginLeft: 40 }}
                />
                <label htmlFor="noQuestion3" style={{ marginLeft: 10 }}>
                  ไม่ใช่
                </label>
              </div>
            </div>
            <div>
              <p>
                4.
                เป็นกิจกรรมจิตอาสาจัดขึ้นให้นักศึกษาทำพื่อประโยชน์ต่อสังคมและสาธารณะ
              </p>
              <div style={{ marginTop: -10 }}>
                <input
                  type="radio"
                  id="yesQuestion4"
                  name="question4"
                  value="yes"
                  onChange={() => handleYes("question4")}
                />
                <label htmlFor="yesQuestion4" style={{ marginLeft: 10 }}>
                  ใช่
                </label>

                <input
                  type="radio"
                  id="noQuestion4"
                  name="question4"
                  value="no"
                  style={{ marginLeft: 40 }}
                  onChange={() => handleNo("question4")}
                />
                <label htmlFor="noQuestion4" style={{ marginLeft: 10 }}>
                  ไม่ใช่
                </label>
              </div>
              {Object.values(answers).filter((value) => value === false)
                .length >= 1 && (
                <p className="mt-4 text-danger">
                  ไม่เป็นลักษณะของกิจกรรมจิตอาสา
                </p>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="success"
              onClick={() => setOpenConModal(false)}
              disabled={Object.values(answers).includes(false) || Object.values(answers).includes(null)}
            >
              ตกลง
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      <h2
        style={{
          textAlign: "center",
          marginTop: 80,
          fontSize: 30,
          fontWeight: "bold",
        }}
        className="thai-font"
      >
        เพิ่มข้อมูลกิจกรรมที่จัดขึ้นโดยคณะวิชา ศูนย์ สำนักของมหาวิทยาลัย
      </h2>
      <div className="form-wrapper">
        <Form className="form_container thai-font">
          <Form.Group controlId="activityName" className="form-group">
            <Form.Label>
              ชื่อกิจกรรม <span style={{ color: "red" }}>*</span>{" "}
            </Form.Label>
            <Form.Control
              type="text"
              value={activityName}
              onChange={(e) => setActivityName(e.target.value)}
            />
            {errors.activityName && (
              <div className="text-danger">{errors.activityName}</div>
            )}
          </Form.Group>

          <Form.Group controlId="activity" className="form-group">
            <Form.Label>
              ปีการศึกษา/ภาคเรียน <span style={{ color: "red" }}>*</span>
            </Form.Label>
            <Form.Control
              as="select"
              value={activityYear}
              onChange={(e) => setActivityYear(e.target.value)}
            >
              <option value="">-- เลือก --</option>
              {semesterOptions.map((semester) => (
                <option key={semester.Sem_ID} value={semester.Formatted_Sem}>
                  {semester.Formatted_Sem}
                </option>
              ))}
            </Form.Control>
            {errors.activityYear && (
              <div className="text-danger">{errors.activityYear}</div>
            )}
          </Form.Group>

          <Form.Group controlId="department" className="form-group">
            <Form.Label>
              กิจกรรมจัดขึ้นโดย <span style={{ color: "red" }}>*</span>
            </Form.Label>
            <Form.Control
              as="select"
              value={selectedDepartment}
              onChange={(e) => setSelectedDepartment(e.target.value)}
            >
              <option value="">-- เลือก --</option>
              {department.map((dep) => (
                <option
                  value={`${dep.Fac_ID},${dep.Fac_NameTH}`}
                  key={dep.Fac_ID}
                >
                  {dep.Fac_NameTH}
                </option>
              ))}
            </Form.Control>
            {errors.selectedDepartment && (
              <div className="text-danger">{errors.selectedDepartment}</div>
            )}
          </Form.Group>

          <Form.Group controlId="activityDate" className="form-group">
            <Form.Label>
              วันที่จัดกิจกรรม: <span style={{ color: "red" }}>*</span>{" "}
              <span style={{ color: "green", fontWeight: "bold" }}>
                {formattedDate}
              </span>
            </Form.Label>
            <label className="date-picker">
              <DatePicker
                selected={activityDate}
                startDate={activityDate}
                endDate={lastDate}
                selectsStart
                onChange={handleDateChange}
                dateFormat="dd/MM/yyyy"
                locale="th"
                className="form-control"
              />
              <CalendarMonthIcon className="calendar-icon" />
            </label>
            {errors.activityDate && (
              <div className="text-danger">{errors.activityDate}</div>
            )}
          </Form.Group>

          <Form.Group controlId="activityLastDate" className="form-group">
            <Form.Label>
              วันสิ้นสุดกิจกรรม: <span style={{ color: "red" }}>*</span>{" "}
              <span style={{ color: "green", fontWeight: "bold" }}>
                {formattedLastDate}
              </span>
            </Form.Label>
            <label className="date-picker">
              <DatePicker
                selected={lastDate}
                selectsEnd
                startDate={activityDate}
                endDate={lastDate}
                minDate={activityDate}
                onChange={handleLastDateChange}
                dateFormat="dd/MM/yyyy"
                locale="th"
                className="form-control"
              />
              <CalendarMonthIcon className="calendar-icon" />
            </label>
            {errors.lastDate && (
              <div className="text-danger">{errors.lastDate}</div>
            )}
          </Form.Group>

          <Form.Group controlId="activityPlace" className="form-group">
            <Form.Label>
              สถานที่จัดกิจกรรม <span style={{ color: "red" }}>*</span>
            </Form.Label>
            <Form.Control
              type="text"
              value={activityPlace}
              onChange={(e) => setActivityPlace(e.target.value)}
            />
            {errors.activityPlace && (
              <div className="text-danger">{errors.activityPlace}</div>
            )}
          </Form.Group>

          <Form.Group controlId="activityPicture" className="form-group">
            <Form.Label>ภาพประชาสัมพันธ์โครงการ/กิจกรรม</Form.Label>
            <p style={{ fontSize: 18, color: "black" }}>
              หมายเหตุ: จํานวน 1 ภาพ (ถ้ามี)
            </p>
            <Form.Control
              type="file"
              accept="image/*"
              multiple
              label="เลือกไฟล์แนบ" // The Thai text here
              name="activity_pictures" // add this line
              onChange={(e) =>
                setActivityPictures([...activityPictures, ...e.target.files])
              }
            />

            <div>
              {activityPictures.map((file, index) => (
                <div
                  key={index}
                  style={{
                    position: "relative",
                    display: "inline-block",
                  }}
                >
                  <img
                    src={URL.createObjectURL(file)}
                    alt={file.name}
                    style={{
                      width: 120,
                      height: 120,
                      marginTop: 10,
                      padding: 10,
                    }}
                  />
                  <button
                    onClick={(event) => handleDeletePicture(event, index)}
                    style={{
                      position: "absolute",
                      marginTop: 10,
                      top: 0,
                      right: 0,
                      padding: "1px 3px",
                      borderRadius: "50%",
                      background: "red",
                      color: "white",
                      border: "none",
                      cursor: "pointer",
                    }}
                  >
                    X
                  </button>
                </div>
              ))}
            </div>
          </Form.Group>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Button
              onClick={() => handleFormSubmit()}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginTop: "10px",
                marginBottom: 20,
                border: "none",
                alignSelf: "center",
                textAlign: "center",
                fontSize: 20,
              }}
            >
              เพิ่มข้อมูลกิจกรรม
            </Button>
          </div>
        </Form>
      </div>
      {loading && (
        <div>
          <Loader className="thai-font" />
        </div>
      )}
    </div>
  );
};

export default Teacher_Form;
